module.exports = __webpack_public_path__ + "img/case-bg-1.92fe8a90.png";